// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-deduction-pay.json
export class HrPayDeductionKey {
    private static readonly keyPrefix = 'hrPayDeduction';
    public static pageHeader = `${HrPayDeductionKey.keyPrefix}.pageHeader`;
    public static blockage = `${HrPayDeductionKey.keyPrefix}.blockage`;
    public static active = `${HrPayDeductionKey.keyPrefix}.active`;
    public static wageCode = `${HrPayDeductionKey.keyPrefix}.wageCode`;
    public static wageName = `${HrPayDeductionKey.keyPrefix}.wageName`;
    public static wageType = `${HrPayDeductionKey.keyPrefix}.wageType`;
    public static emptyStateMainTitle = `${HrPayDeductionKey.keyPrefix}.emptyStateMainTitle`;
    public static emptyStateSubtitle = `${HrPayDeductionKey.keyPrefix}.emptyStateSubtitle`;
}
